import React, { useState } from 'react';
import Button from '@mui/material/Button';
import UploadInvoicesMethodDialog, {
  UPLOAD_INVOICES_METHODS,
} from '../dialogs/UploadInvoicesMethodDialog';
import UploadNominaDialog from '../dialogs/UploadNominaDialog';
import UploadSiiCredentialsDialog from '../dialogs/UploadSiiCredentialsDialog';

const STEPS = {
  CLOSED: 'closed',
  METHOD: 'method',
  MANUAL: 'manual',
  SII: 'sii',
};

const UploadInvoicesButton = () => {
  const [step, setStep] = useState(STEPS.CLOSED);

  const handleContinue = (selectedMethod) => {
    if (selectedMethod === UPLOAD_INVOICES_METHODS.MANUAL) {
      setStep(STEPS.MANUAL);
    } else if (selectedMethod === UPLOAD_INVOICES_METHODS.SII) {
      setStep(STEPS.SII);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        size="large_2"
        onClick={() => setStep(STEPS.METHOD)}
      >
        Cargar facturas
      </Button>
      <UploadInvoicesMethodDialog
        open={step === STEPS.METHOD}
        onClose={() => setStep(STEPS.CLOSED)}
        onContinue={handleContinue}
      />
      <UploadNominaDialog
        open={step === STEPS.MANUAL}
        onClose={() => setStep(STEPS.CLOSED)}
        onBack={() => setStep(STEPS.METHOD)}
      />
      <UploadSiiCredentialsDialog
        open={step === STEPS.SII}
        onClose={() => setStep(STEPS.CLOSED)}
        onBack={() => setStep(STEPS.METHOD)}
      />
    </>
  );
};

export default UploadInvoicesButton;
